import { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { FkIcon } from "./Icons";
import { AccountMenu, initials } from "./AccountMenu";
import { HeaderBell } from "./NotificationsBell";
import {
  GROUP_LABEL,
  PageTitleContext,
  ROOT_LABEL,
  pageMetaFor,
} from "./pageMeta";

export { initials };

export const WIKI_URL = "https://wiki.brasol.ru/";

/** Плашка баланса в шапке: партнёру — свой счёт, УК — сумма счетов партнёров. */
export interface TopbarBalance {
  /** Уже отформатированная сумма («12 345,60 ₽»). */
  label: string;
  /** Подсказка и подпись для диктора. */
  title: string;
  to: string;
  kind: "hq" | "partner";
}

export interface TopbarUser {
  name: string;
  roleLabel: string;
  company?: string;
}

/**
 * Шапка каркаса CRM v2: бургер (<900), крошка «группа › экран», баланс,
 * «База знаний», колокольчик, меню аккаунта.
 */
export function Topbar({
  menuOpen,
  onToggleMenu,
  balance,
  user,
  onLogout,
}: {
  menuOpen: boolean;
  onToggleMenu: () => void;
  /** null/undefined — плашки нет (нет права billing или сервер не прислал итогов). */
  balance?: TopbarBalance | null;
  user: TopbarUser;
  onLogout: () => void;
}) {
  const { pathname } = useLocation();
  const { override } = useContext(PageTitleContext);
  const meta = pageMetaFor(pathname);
  const group = meta.group ? GROUP_LABEL[meta.group] : ROOT_LABEL;
  const title = override || meta.title;
  return (
    <header className="fk-topbar">
      <button
        type="button"
        className="fk-burger"
        aria-label={menuOpen ? "Закрыть меню" : "Открыть меню"}
        aria-expanded={menuOpen}
        aria-controls="fk-sidebar"
        onClick={onToggleMenu}
      >
        <FkIcon name="menu" size={20} />
      </button>
      <div className="fk-crumb">
        <span className="fk-crumb-group">{group}</span>
        <FkIcon name="chevR" size={13} className="fk-crumb-sep" />
        <span className="fk-title" title={title}>
          {title}
        </span>
      </div>
      {balance && (
        <Link
          className={`fk-balance fk-balance-${balance.kind}`}
          to={balance.to}
          title={balance.title}
          aria-label={`${balance.title}: ${balance.label}`}
        >
          <FkIcon name={balance.kind === "hq" ? "wallet" : "card"} size={15} />
          <span className="fk-mono">{balance.label}</span>
        </Link>
      )}
      <a
        className="fk-icon-btn fk-wiki-link"
        href={WIKI_URL}
        target="_blank"
        rel="noopener noreferrer"
        title="База знаний (wiki.brasol.ru)"
        aria-label="База знаний"
      >
        <FkIcon name="bookOpen" size={16} />
      </a>
      <HeaderBell />
      <AccountMenu
        name={user.name}
        roleLabel={user.roleLabel}
        company={user.company}
        onLogout={onLogout}
      />
    </header>
  );
}
